import { render, staticRenderFns } from "./ScreeningQuestionsAnswers.vue?vue&type=template&id=d0720b8a"
import script from "./ScreeningQuestionsAnswers.vue?vue&type=script&lang=ts"
export * from "./ScreeningQuestionsAnswers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports